import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum HelpIconVariant {
  DEFAULT = 'default',
}
export interface IHelpIconProps extends IConDefaultType {
  variant?: HelpIconVariant;
}
export default function HelpIcon({
  color = '#C4C6C9',
  className,
  size = 20,
  rotate,
  flip,
  variant = HelpIconVariant.DEFAULT,
}: IHelpIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };
  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === HelpIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10.2149 6.77179C9.83106 6.70596 9.4363 6.77808 9.10055 6.97537C8.76481 7.17266 8.50976 7.48238 8.38055 7.84965C8.24307 8.24038 7.81488 8.4457 7.42414 8.30822C7.03341 8.17075 6.82809 7.74256 6.96557 7.35182C7.21236 6.65035 7.69948 6.05888 8.34061 5.68213C8.98174 5.30538 9.73552 5.16767 10.4685 5.29337C11.2014 5.41907 11.8662 5.80008 12.3451 6.36893C12.824 6.93774 13.0862 7.65765 13.0851 8.40119C13.0847 9.59844 12.1965 10.3935 11.5516 10.8233C11.2062 11.0535 10.8662 11.223 10.6155 11.3344C10.4891 11.3906 10.3827 11.4332 10.3062 11.4623C10.2678 11.477 10.2368 11.4882 10.2143 11.4963L10.187 11.5058L10.1784 11.5088L10.1754 11.5098L10.1742 11.5102L9.93611 10.7989C10.1732 11.5105 10.174 11.5102 10.1742 11.5102C9.78123 11.6411 9.35556 11.4291 9.22459 11.0361C9.09378 10.6436 9.30546 10.2195 9.69746 10.0879L9.69897 10.0874L9.71182 10.0829C9.72445 10.0784 9.74496 10.071 9.77223 10.0606C9.82687 10.0398 9.9079 10.0074 10.0064 9.96366C10.2055 9.87518 10.4652 9.7448 10.7196 9.57522C11.2741 9.20562 11.5851 8.80164 11.5851 8.40029L11.5851 8.39917C11.5857 8.00985 11.4484 7.63288 11.1977 7.33501C10.9469 7.03715 10.5988 6.83762 10.2149 6.77179ZM9 14C9 13.4477 9.44593 13 9.99602 13H10.004C10.5541 13 11 13.4477 11 14C11 14.5523 10.5541 15 10.004 15H9.99602C9.44593 15 9 14.5523 9 14Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}
